import React from 'react';
import { connect } from 'react-redux';
import { withRouter, WithRouterProps } from 'react-router';

import { withIntl, IntlProps } from 'ha/i18n';
import { GlobalState } from 'ha/types/store';
import { getImpersonatingAdmin } from '../selectors';
import { impersonateUser } from '../actions';

interface ImpersonatingAdmin {
  id: number;
  name: string;
}

interface ChildrenFn {
  impersonatingAdmin: ImpersonatingAdmin | null;
  onStop: () => void;
}

interface Props {
  impersonatingAdmin: ImpersonatingAdmin | null;
  children: (args: ChildrenFn) => React.ReactNode;
  onImpersonate: (id: number, nextUrl: string) => void;
}

export class ImpersonationContainer extends React.Component<
  Props & IntlProps & WithRouterProps
> {
  handleStop = () => {
    const {
      onImpersonate,
      intl: { urlResolver },
    } = this.props;

    onImpersonate(0, urlResolver.getAdminPagesUrl());
  };

  render() {
    const { children, impersonatingAdmin } = this.props;

    return children({
      impersonatingAdmin,
      onStop: this.handleStop,
    });
  }
}

export default connect(
  (state: GlobalState) => ({
    impersonatingAdmin: getImpersonatingAdmin(state),
  }),
  {
    onImpersonate: impersonateUser,
  },
)(withIntl(withRouter(ImpersonationContainer)));
